import type {
  ICertificateService,
  IssueCertificateParams,
} from '@/domain/precon-supporter/services';
import type { CertificateData } from '@/domain/precon-supporter/types';

/**
 * 修了証サービスの実装
 */
export class CertificateService implements ICertificateService {
  // メモリ上に保存（実際のシステムではデータベースやストレージに保存）
  private certificates: Map<string, CertificateData> = new Map();

  /**
   * 修了証を発行
   */
  async issue(params: IssueCertificateParams): Promise<CertificateData> {
    const certificateId = `cert_${params.courseId.toString()}_${Date.now()}`;

    const certificate: CertificateData = {
      id: certificateId,
      courseId: params.courseId.toString() as 'basic' | 'advanced',
      issuedAt: new Date().toISOString(),
      score: params.score,
      statistics: params.statistics,
    };

    this.certificates.set(certificateId, certificate);

    return certificate;
  }

  /**
   * 修了証を取得
   */
  async get(certificateId: string): Promise<CertificateData | null> {
    return this.certificates.get(certificateId) || null;
  }

  /**
   * すべての修了証を取得
   */
  async listAll(): Promise<CertificateData[]> {
    return Array.from(this.certificates.values());
  }
}
